module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "project-created-data",
    attrs: {
      "span": 16,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "select-bar"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('createProjectNum')))]), _vm._v(" "), _c('el-select', {
    staticClass: "select-box",
    attrs: {
      "placeholder": _vm.$t('common.placeholder.plzChoose')
    },
    model: {
      value: (_vm.projectsCreatedPeriod),
      callback: function($$v) {
        _vm.projectsCreatedPeriod = $$v
      },
      expression: "projectsCreatedPeriod"
    }
  }, _vm._l((_vm.periods), function(p) {
    return _c('el-option', {
      key: p,
      attrs: {
        "label": _vm.$t("periods.past") + _vm.$t(("periods." + p)),
        "value": p
      }
    })
  }))], 1), _vm._v(" "), _c('line-chart', {
    staticClass: "pv-chart",
    attrs: {
      "data": _vm.projectsCreatedData,
      "min": 0,
      "library": _vm.projectsCreatedChartOptions
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "summary",
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "item blue"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.quotas.members))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "item orange"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.projects))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "item green"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.pv))]), _vm._v(" "), _vm._m(2)])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_vm._m(3), _vm._v(" "), _c('el-table', {
    staticClass: "recent-projects",
    attrs: {
      "data": _vm.recentProjects,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.nickname",
      "label": _vm.$t('projectCreator')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('projectCreatedDate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dateReadable(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pv",
      "label": _vm.$t('projectPV')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.tablehead.action')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "text-btn",
          on: {
            "click": function($event) {
              _vm.projectDialog(scope.row)
            }
          }
        }, [_vm._m(4)])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('packageAccountsTotalNum')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('projectsTotalNum')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('projectsTotalPV')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-weight": "600",
      "margin": "2em 1em"
    }
  }, [_vm._v(_vm._s(_vm.$t('recentCreateProjectList')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.$t('seeAndShare')))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36a639fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/index.vue
// module id = 909
// module chunks = 3